module.exports = __webpack_public_path__ + "static/media/split-cross.fa0be1a3.svg";